module.exports = __webpack_public_path__ + "static/media/aqua2.905b1924.jpg";